/**
 * Verify Pass Discount Form
 * Handles form submission to Qcontact API
 */

document.addEventListener('DOMContentLoaded', function() {
  const forms = document.querySelectorAll('[data-discount-form]');
  
  forms.forEach(function(formElement) {
    if (!(formElement instanceof HTMLFormElement)) return;
    
    const discountForm = formElement.closest('.discount-form');
    if (!discountForm) return;
    
    const successMessage = discountForm.querySelector('[data-success-message]');
    const failedMessage = discountForm.querySelector('[data-failed-message]');
    const formUrl = formElement.dataset.formUrl;
    if (!formUrl) return;
    
    const submitButton = formElement.querySelector('[data-submit-button]');
    const buttonText = submitButton?.querySelector('[data-button-text]');
    const buttonLoading = submitButton?.querySelector('[data-button-loading]');
    const formFields = formElement.querySelectorAll('[data-form-field]');
    
    // Handle form validation
    formFields.forEach(function(field) {
      if (!(field instanceof HTMLInputElement)) return;
      
      field.addEventListener('invalid', function(event) {
        event.preventDefault();
        field.setAttribute('aria-invalid', 'true');
      });
      
      field.addEventListener('input', function() {
        if (field.validity.valid) {
          field.setAttribute('aria-invalid', 'false');
        }
      });
    });
    
    formElement.addEventListener('submit', async function(event) {
      event.preventDefault();
      
      // Validate form
      if (!formElement.checkValidity()) {
        const firstInvalid = formElement.querySelector(':invalid');
        if (firstInvalid instanceof HTMLElement) {
          firstInvalid.focus();
          if (firstInvalid instanceof HTMLInputElement) {
            firstInvalid.setAttribute('aria-invalid', 'true');
          }
        }
        return;
      }
      
      // Hide previous messages
      if (successMessage) {
        successMessage.classList.add('is-hidden');
      }
      if (failedMessage) {
        failedMessage.classList.add('is-hidden');
      }
      
      // Set loading state
      if (submitButton instanceof HTMLButtonElement) {
        submitButton.setAttribute('aria-busy', 'true');
        submitButton.disabled = true;
        if (buttonText) {
          buttonText.classList.add('is-hidden');
        }
        if (buttonLoading) {
          buttonLoading.classList.remove('is-hidden');
          buttonLoading.setAttribute('aria-hidden', 'false');
        }
      }
      
      // Get form data
      const formData = new FormData(formElement);
      /** @type {Record<string, string>} */
      const formObject = {};
      formData.forEach((value, key) => {
        formObject[key] = String(value);
      });
      const json = JSON.stringify(formObject);
      
      try {
        // Submit to Qcontact
        const response = await fetch(formUrl, {
          method: 'POST',
          body: json,
          headers: {
            'Content-Type': 'application/json',
          },
        });
        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        
        const data = await response.json();
        
        // Show success message
        formElement.classList.add('is-hidden');
        if (successMessage instanceof HTMLElement) {
          successMessage.classList.remove('is-hidden');
          // Focus on success message for screen readers
          if (typeof successMessage.focus === 'function') {
            successMessage.focus();
          }
        }
        
        return data;
      } catch (error) {
        // Show failed message
        formElement.classList.add('is-hidden');
        if (failedMessage instanceof HTMLElement) {
          failedMessage.classList.remove('is-hidden');
          // Focus on error message for screen readers
          if (typeof failedMessage.focus === 'function') {
            failedMessage.focus();
          }
        }
        
        console.error('Form submission failed:', error);
        throw error;
      } finally {
        // Reset loading state
        if (submitButton instanceof HTMLButtonElement) {
          submitButton.setAttribute('aria-busy', 'false');
          submitButton.disabled = false;
          if (buttonText) {
            buttonText.classList.remove('is-hidden');
          }
          if (buttonLoading) {
            buttonLoading.classList.add('is-hidden');
            buttonLoading.setAttribute('aria-hidden', 'true');
          }
        }
      }
    });
  });
});

